module.exports = __webpack_public_path__ + "img/304a78d.jpg";